
export enum ShipmentOnTimeStatusCd {
	EARLY = 'Early',
	LATE = 'Late',
	ON_TIME = 'OnTime'}

